// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__32s3f","inputWrap":"Table_inputWrap__214it","col":"Table_col__1UxfM","bmiTooltip":"Table_bmiTooltip__ryOiG"};